import FormRenderer from 'pages/workspace/forms/formrenderer';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import styles from './publicform.module.scss';
import { KoButton, KoImage, KoLoader, KoText, KoTitle } from 'packages';
import { Layout } from 'antd';
export default function PublicForm({formData}) {
  const { workspaceId, formId, requestId } = useParams();
  // const [form] = KoForm.useForm();
  const [isLoading ] = useState(false);

  const { Header } = Layout;
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <Header className={styles.shallowHeader}></Header>
      <Header className={styles.globalHeader}>
        <div className={styles.docHeader}>
          <div className={styles.docHeaderLeft}>
            <div className={styles.iconWrapper}>
              <KoImage src={'https://littleelly.com/wp-content/uploads/2025/06/logo.IYvJkGUK.png'} width={30}  />
            </div>
            <KoTitle className={styles.docTitle} level={4} text={formData?.name || 'Form'} />
          </div>
          <div className={styles.docHeaderRight}>
            <div className={styles.userWrapper} >
              {requestId && <KoText ellipsis={true} className={styles.name} text={`${requestId}`} />}
            </div>
            <KoButton className={styles.btn} type="primary" label="Submit" />
          </div>
        </div>
      </Header>
      <FormRenderer workspaceId={workspaceId} formId={formId}/>
    </div>
  );
}
